module.exports = __webpack_public_path__ + "img/img7.777163e2.png";